import { Component, Fragment } from 'react';
import {
  DKLabel,
  DKIcons,
  DKButton,
  DKListPicker,
  INPUT_TYPE,
  showAlert,
  DKIcon,
  DKInput,
  DKTooltipWrapper,
  removeLoader,
  showLoader,
  showToast,
  TOAST_TYPE,
  DKSpinner,
  DKCheckMark
} from 'deskera-ui-library';
import {
  APPROVAL_ACTIONS,
  // APPROVAL_ACTIONS,
  APPROVAL_REQURIED_CONDITION,
  AUTOMATION_TRIGGERS,
  DOCUMENTS,
  SPLIT_ACTION_TYPE,
  SPLIT_ACTION_TYPE_CONTEXT
} from '../AutomationConstants';
import { FieldRow } from './FieldMapper';
import React from 'react';


import { Store } from '../../../Redux/Store';
import { INPUT_VIEW_DIRECTION } from '../../SequenceNumberFormat/Other';
import Utility, { deepClone } from '../../../utility/Utility';
import { COLUMN_CODE, TableManger, TABLES } from '../../../managers/TableManger';
import { isIndiaCompliance, showAlertEmployeeExpense } from '../../../managers/common/CommonUtil';
import UserManager from '../../../managers/UserManager';
import AutomationManager from '../AutomationManager';
import ExpenseService from '../../../services/ExpenseService';
import { fetchTeams, fetchUsersExpenseGroup, fetchUsersListWithTeams } from '../../../Redux/Slices/PayrollSlice';
import { APPLICABLE_TO_ALL } from '../../../constants/Constant';
import PermissionUtils, { ACTION, MODULE } from '../../user-permissions/PermissionUtils';
import { fetchLeaveType } from '../../../Redux/Slices/CompOffSlice';
import { MULTIPLE_OF_05 } from '../../../constants/RegexConstants';
/* PROPS:
 - stepData
 - parentStepId
 - parentStepType
 - onSave
 - onClose
*/

class ApprovalActionPopup extends React.Component<any, any> {
  defaultLogicalOperator: string;
  supportedConditionTypes: string[];
  documentType: string = '';
  userList: any = [];
  approverList: any = [];
  listForApprovalType = AutomationManager.getAllTriggers().filter(trigger => [AUTOMATION_TRIGGERS.PEOPLE_LEAVE_CREATED,AUTOMATION_TRIGGERS.EXPENSE_CREATED].includes(trigger.type)  )
  automationData = AutomationManager.getData();
  workflowColumnId = TableManger.getColumnId(TABLES.PEOPLE_AUTOMATION, COLUMN_CODE.PEOPLE_AUTOMATION.WORKFLOW_ID);
  
  groupList = [];
  teams = [];
  allUsers = [];
  isExpense = this.props.parentStepType === AUTOMATION_TRIGGERS.EXPENSE_CREATED;
  leaveTypes = []
  isMapperInvalid = false
  constructor(props: any) {
    super(props);
    this.defaultLogicalOperator = this.isExpense ? 'and' : 'or';
    this.supportedConditionTypes = Object.keys(SPLIT_ACTION_TYPE).filter(
      (actionType: string) =>
        SPLIT_ACTION_TYPE_CONTEXT[SPLIT_ACTION_TYPE[actionType]]?.includes(
          props.parentStepType
        )
    );

    this.state = {
      activeType: {},
      columns: {},
      needEmailConfigSelection: false,
      logicalOperator: this.initializeOperators() /* [type]: "or" / "and" */,
      configuration:
        this.initializeConfig() /* { [type]: {[fieldId]: {value: "", opr: "eq"}} }*/,
      documentType: '',
      showGetDocumentsOptions: false,
      approvalFor: [],
      approver: [],
      multiApprovalDetails: [],
      sendEmailToApprover: false,
      userList: this.getAllActiveUsers(),
      sendReminder: false,
      reminderDays: 7,
      groupValue:null,
      isLoadingApprovalDetails: this.getUserDataStatus(),
      workflowId : this.automationData?.data?.cells[this.workflowColumnId] || null
    };
    this.userList = this.getAllActiveUsers();

    this.state = {
      ...this.state,
      activeType: APPROVAL_ACTIONS[this.props.parentStepType],
      approvalFor: this.getApprovalForList(),
      approver: this.getApproverList(),
      multiApprovalDetails:
        this.props.stepData?.configuration &&
          this.props.stepData?.configuration[0].multiApprovalDetails
          ? this.getMultiApprovalListFromProps()
          : this.props.stepData?.configuration &&
            this.props.stepData?.configuration[0].approver
            ? [this.getMultiApprovalConfigFromApprover()]
            : [this.getDefaultMultiApprovalConfig()],
      sendEmailToApprover:
        this.props.stepData?.configuration &&
        this.props.stepData?.configuration[0].sendEmailToApprover,
      sendReminder:
        this.props.stepData?.configuration &&
        this.props.stepData?.configuration[0].sendReminder,
      reminderDays: this.props.stepData?.configuration
        ? this.props.stepData?.configuration[0].reminderDays
        : '7',
      logicalOperator: this.props.stepData?.configuration && this.isExpense
        ? this.props.stepData?.configuration[0].logicalOperator
        : this.defaultLogicalOperator,
      // note use later
      groupValue: this.props.stepData?.configuration && this.props.stepData?.configuration[0].group ? this.props.stepData?.configuration[0].group : null,
      isEdit: this.props.stepData?.configuration && this.props.stepData?.configuration[0].group ? true : false,
      isAllRequiredUser: (this.props.stepData?.configuration && this.props.stepData?.configuration[0]?.isAllRequiredUser) ? APPLICABLE_TO_ALL[0]: APPLICABLE_TO_ALL[1]
    };
    this.defaultLogicalOperator = this.props.stepData?.configuration && this.isExpense
      ? this.props.stepData?.configuration[0].logicalOperator
      : this.defaultLogicalOperator;
    this.documentType = APPROVAL_ACTIONS[this.props.parentStepType];
    this.listForApprovalType = this.listForApprovalType.map(obj=>{
      return {
        ...obj,
        label: obj.title,
        id: obj.type
      }
    })
    if(this.state.activeType === AUTOMATION_TRIGGERS.EXPENSE_CREATED) {
      ExpenseService.fetchExpenseGroupCustomLimit({limit: 1000, page:0 }).then((res:any)=>{
        if(res.content) {
          this.groupList = res.content;
          let groupIndex;
          if(this.state.groupValue) {
            groupIndex = this.groupList.findIndex(g=>g.id === this.state.groupValue.id);
          } 
          if(groupIndex === -1) {
            this.setState({
              ...this.state,
              groupValue:null
            })
          } else {
            this.setState({
              ...this.state
            })
          }
            
        }
      })
    } else {
      // get Leaves
    }
  }

  componentDidMount() {
    this.manageDataToRender() 
  }

  manageDataToRender = async() => {
    
    if(!this.isExpense) {
      this.leaveTypes = Store.getState().compOff?.leaveTypes ? Store.getState().compOff?.leaveTypes['data'] : null
      if(Utility.isEmpty(this.leaveTypes)) {
        const result = await Store.dispatch(fetchLeaveType());
        this.leaveTypes = result?.payload['data'] ?? [];
        
      }
      
      this.leaveTypes = this.leaveTypes?.map(leave=> {
        return {
          id: leave._id,
          name: leave.leaveType,
          type: 'number'
        }
      })
    }
    this.setFieldsData();
  }

  getAllActiveUsers=()=> {

    if (this.isExpense) {
      return this.getExpenseUsers();
    } else {
      return this.getUsersWithTeam();
    }
  }
  getUserDataStatus =() => {
    if (this.isExpense) {
      return Utility.isEmpty(Store.getState().payroll?.formData?.userWithExpenseGroup)
    } else {
      return Utility.isEmpty(Store.getState().payroll?.formData?.teams)
    }
  }
  getUsersWithTeam() {
    if (!Utility.isEmpty(Store.getState().payroll?.formData?.teams) &&
        Store.getState().payroll?.formData?.teams['teams']) {
          const teamList = Store.getState().payroll?.formData?.teams['teams']
          this.groupList = teamList;
            
           this.allUsers = Store.getState().payroll?.formData?.teams['teams'][0].members;
            let group = null;
            if(this.props.stepData?.configuration && this.props.stepData?.configuration[0].group ) {

              group = this.props.stepData?.configuration[0].group
              if(teamList && group.teamId) {
                group = teamList.find(t=>t.teamId === group.teamId)
              }
            }
          this.userList = (group && group.members) ? group.members:this.allUsers
        return this.userList
      } else {
        const getUsers = async () => {
          const response = await Store.dispatch(fetchTeams());
          if(response && response['error']) {
            showToast((response['message'] ? response['message']:"Unable to Load teams.") ,TOAST_TYPE.FAILURE);
            this.setState({
              ...this.state,
              isLoadingApprovalDetails:false
            })
          }
          if (
            !Utility.isEmpty(Store.getState().payroll?.formData?.teams) &&
            Store.getState().payroll?.formData?.teams['teams']
          ) {
            const teamList = Store.getState().payroll?.formData?.teams['teams']
            this.groupList = teamList;
            let group = null;
            if(this.props.stepData?.configuration && this.props.stepData?.configuration[0].group ) {

              group = this.props.stepData?.configuration[0].group
              if(teamList) {
                group = teamList.find(t=>t.teamId === group.teamId)
              }
            }
             
            this.userList = (group && group.members) ? group.members:this.allUsers
            if(this.groupList && !Utility.isEmpty(this.groupList[0])) {
              this.allUsers = group ? this.userList : this.groupList[0].members
            }
            // this.allUsers
            this.updateUserListResponse()
            
          } else {
            return [];
          }
        }
        getUsers();
        return []
      }
  }

  getExpenseUsers() {
    if (!Utility.isEmpty(Store.getState().payroll?.formData?.userWithExpenseGroup) &&
        Store.getState().payroll?.formData?.userWithExpenseGroup['content']) {
        this.allUsers = Store.getState().payroll?.formData?.userWithExpenseGroup['content']; 
        return this.getFilterUsers(this.allUsers)
      } else {
        
         const getUsers = async () => {
          const response = await Store.dispatch(fetchUsersExpenseGroup());
          if(response && response['error']) {
            showToast((response['message'] ? response['message']:"Unable to Load user with expense.") ,TOAST_TYPE.FAILURE);
            this.setState({
              ...this.state,
              isLoadingApprovalDetails:false
            })
          }
          if (
            !Utility.isEmpty(Store.getState().payroll?.formData?.userWithExpenseGroup) &&
            Store.getState().payroll?.formData?.userWithExpenseGroup['content']
          ) {
            
            this.allUsers = Store.getState().payroll?.formData?.userWithExpenseGroup['content'];
            this.updateUserListResponse()
            
          } else {
            return [];
          }
        }
        getUsers();
        return []
      }
  }
  updateUserListResponse() {
    this.userList = this.getFilterUsers(this.allUsers)
    let newState = {
      ...this.state,
      isLoadingApprovalDetails: false,
      userList: this.userList,
      approvalFor: this.getApprovalForList(),
      approver: this.getApproverList(),
      
    }
    if(this.props.stepData?.configuration &&
      this.props.stepData?.configuration[0].multiApprovalDetails
      ? this.getMultiApprovalListFromProps()
      : this.props.stepData?.configuration &&
        this.props.stepData?.configuration[0].approver) {
          newState['multiApprovalDetails']=
          this.props.stepData?.configuration &&
            this.props.stepData?.configuration[0].multiApprovalDetails
            ? this.getMultiApprovalListFromProps()
            : this.props.stepData?.configuration &&
              this.props.stepData?.configuration[0].approver
              ? [this.getMultiApprovalConfigFromApprover()]
              : [this.getDefaultMultiApprovalConfig()]
        }
        
    newState['groupValue']= this.props.stepData?.configuration && this.props.stepData?.configuration[0].group ? this.props.stepData?.configuration[0].group:null;
    this.setState({...newState})
  }
  getFilterUsers(userList) {
    let config = this.props.stepData?.configuration;
    let approverForlist =
      !Array.isArray(config && config[0]) &&
      config &&
      config[0] !== '' &&
      config &&
      !Utility.isEmpty(config[0].approvalFor) &&
      config[0].approvalFor.split(',');
    
    if (approverForlist && approverForlist.length > 0) {
      let defaultGroup = userList.find(u=>u.iamUserId == approverForlist[0]);
      if(this.isExpense) {
        let group = this.props.stepData?.configuration && this.props.stepData?.configuration[0].group
        userList = this.allUsers.filter(u=>u.userGroup.id == group?.id)?.map(u=>{return {...u,iamUserId:parseInt(u.iamUserId)}});
      } else {
        let group = this.props.stepData?.configuration && this.props.stepData?.configuration[0].group
        this.userList = ((group && group.members) ? group.members:this.allUsers)?.map(u=>{return {...u,iamUserId:parseInt(u.iamUserId)}})
      }
      
    }
    
    return userList
  }
  initializeConfig() {
    const { stepData } = this.props;

    const newConfiguration: any = {};

    stepData?.configuration?.forEach((configTypeData: any) => {
      const newFields: any = {};

      configTypeData.fields.forEach((fieldData: any) => {
        const opr = fieldData.opr || 'eq';
        delete fieldData[opr];
        const fieldKey = Object.keys(fieldData)[0];
        const value = fieldData[fieldKey];

        newFields[fieldKey] = { value: value, opr: opr, type: fieldData['type'] };
      });
      configTypeData['documentType'] = APPROVAL_ACTIONS[this.props.parentStepType];
      newConfiguration[configTypeData.documentType] = newFields;
    });

    return newConfiguration;
  }

  initializeOperators() {
    const { stepData } = this.props;
    const newOperators: any = {};

    stepData?.configuration?.forEach((configTypeData: any) => {
      if (configTypeData.logicalOperator) {
        newOperators[configTypeData.type] = configTypeData.logicalOperator;
      }
    });

    return newOperators;
  }

  ////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////
  /////////////////////FIELD HANDLERS/////////////////////////

  getColumnFilterFOrApprovalFunc(column: any) {
    let returnVal = false;
    if (
      // column.uiVisible &&
      column.type.toLowerCase() !== 'select' &&
      column.columnCode !== 'documentSequenceCode' &&
      column.columnCode !== 'purchaseInvoiceType' &&
      column.columnCode !== 'approvalStatus' &&
      column.columnCode !== 'dueAmount' &&
      column.columnCode !== 'attachments' &&
      column.columnCode !== 'number' &&
      column.columnCode !== 'totalQty' &&
      column.columnCode !== 'createBy'
    )
      returnVal = true;
    if (TableManger.isSelectField(column) && column.options.length === 0)
      returnVal = false;

    return returnVal;
  }

  getColumnFilterFunc(column: any) {
    let returnVal = false;
    if (column.uiVisible && column.type !== 'Date') returnVal = true;
    if (TableManger.isSelectField(column) && column.options.length === 0)
      returnVal = false;
    if (!column.uiVisible && !column.systemField && column.type !== 'Date')
      returnVal = true;
    return returnVal;
  }

  addField(column: any) {
    const newConfiguration = Utility.makeCopyOfObject(this.state.configuration);
    newConfiguration[this.state.activeType] =
      newConfiguration[this.state.activeType] || {};
    newConfiguration[this.state.activeType][column.id] = {
      value: TableManger.isSelectField(column) ? column.options[0].id : '',
      opr: this.state.activeType === AUTOMATION_TRIGGERS.EXPENSE_CREATED || this.state.activeType === AUTOMATION_TRIGGERS.PEOPLE_LEAVE_CREATED ? 'gt' : 'eq',
      type:  column.name || '',
    };
    this.setState({
      configuration: newConfiguration
    });
  }

  addApprovalLevel() {
    if(this.state.isLoadingApprovalDetails) {
      return
    }
    this.setState({
      multiApprovalDetails: [
        ...this.state.multiApprovalDetails,
        this.getDefaultMultiApprovalConfig()
      ]
    });
  }

  removeApprovalLevel(level: any) {
    const updatedLevels = this.state.multiApprovalDetails.filter(
      (l: { level: any }) => l.level != level
    );
    this.setState({
      multiApprovalDetails: updatedLevels
    });
    setTimeout(()=>{
      this.approvalUserChange(this.state.approvalFor);
    },100)
  }

  showRandomField(visibleFields: any = []) {
    const { columns } = this.state;
    Object.keys(columns).some((key) => {
      if (visibleFields.includes(key)) return false;

      this.addField(columns[key]);
      return true;
    });
  }

  setFieldsData() {

    const activeType = this.documentType;

    let newColumns: any = {};
    switch (activeType) {
      
      case AUTOMATION_TRIGGERS.EXPENSE_CREATED:
        let requisitionColumns = TableManger.getTableFilteredColumns(
          TABLES.PEOPLE_EXPENSE_CLAIMS,
          this.getColumnFilterFOrApprovalFunc,
          false
        );
        requisitionColumns = this.filterColumns(requisitionColumns)
        requisitionColumns.forEach((column: any) => {
          newColumns[column.id] = Utility.makeCopyOfObject(column);
        });
        break;
      case AUTOMATION_TRIGGERS.PEOPLE_LEAVE_CREATED:
        const columnConfig = [
          {
            id: 'any',
            name: 'Any',
            type: "number"
          },
          ...this.leaveTypes
        ]
        columnConfig.forEach(column=> {
          newColumns[column.id] = this.createColumnConfig(column)
        })
        break;
      default:
        let defaultCol = TableManger.getTableFilteredColumns(
          TABLES.PEOPLE_EXPENSE_CLAIMS,
          this.getColumnFilterFOrApprovalFunc,
          false
        );
        defaultCol.forEach((column: any) => {
          newColumns[column.id] = Utility.makeCopyOfObject(column);
        });
        break;
    }

    this.setState({ columns: newColumns });
  }
  createColumnConfig = (data) => {
    return {
      columnCode: `${data.id}_field`,
      editable: false,
      hidden: false,
      id: data.id,
      index: 0,
      key: data.id,
      name: data.name,
      options: [],
      required: true,
      systemField: true,
      type: data.type,
      uiVisible: true,
      width: 100
    }
  }
  filterColumns(columns: any) {
    let updatedColumns = columns.filter(
      (ele: any) =>
        ele.columnCode == 'documentSequenceCode' ||
        ele.columnCode == 'totalAmount'
    );
    return updatedColumns;
  }
  onFieldUpdate = (
    fieldKey: any,
    valueType: any,
    token: any,
    newField?: any,
    oldField?: any
  ) => {
    const newConfiguration = Utility.makeCopyOfObject(this.state.configuration);

    if (oldField) {
      const newKey = Object.keys(newField)[0];
      newConfiguration[this.state.activeType] = this.reorderFields(
        newConfiguration[this.state.activeType],
        fieldKey,
        newKey,
        newField
      );
    } else {
      newConfiguration[this.state.activeType] =
        newConfiguration[this.state.activeType] || {};
      newConfiguration[this.state.activeType][fieldKey] =
        newConfiguration[this.state.activeType][fieldKey] || {};

      newConfiguration[this.state.activeType][fieldKey][valueType] = token;
    }

    this.setState({ configuration: newConfiguration });
  };

  reorderFields(fields: any, oldKey: any, newKey: any, newValue: any) {
    let newFields: any = {};
    Object.keys(fields).forEach((key) => {
      if (key === oldKey) {
        newFields[newKey] = { 
          value: newValue[newKey], 
          opr: this.state.activeType === AUTOMATION_TRIGGERS.EXPENSE_CREATED || this.state.activeType === AUTOMATION_TRIGGERS.PEOPLE_LEAVE_CREATED ? 'gt' : 'eq' ,
          type: newValue['type'] || ''
        };
      } else {
        newFields[key] = fields[key];
      }
    });
    return newFields;
  }

  onFieldRemove = (fieldKey: any) => {
    const newConfiguration = Utility.makeCopyOfObject(this.state.configuration);
    if (newConfiguration[this.state.activeType]) {
      delete newConfiguration[this.state.activeType][fieldKey];
    } else {
      delete newConfiguration['undefined'][fieldKey];
    }

    this.setState({ configuration: newConfiguration });
  };

  handleOperatorChange = (newOperator: any) => {
    this.setState((prevState: any) => ({
      logicalOperator: {
        ...prevState.logicalOperator,
        [this.state.activeType]: newOperator
      }
    }));
  };

  ////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////
  //////////////////////POPUP HANDLERS////////////////////////
  onSave = async() => {
    if (this.isSaveDisabled()) {
      showAlert('Non Admin users do not have access to edit approval flow', '');
      return;
    }

    const { configuration, logicalOperator, documentType } = this.state;
    let remoteTable = '';
    if (this.documentType == AUTOMATION_TRIGGERS.EXPENSE_CREATED) {
      remoteTable = TABLES.PEOPLE_EXPENSE_CLAIMS;
    }

    let approvalUsers: any = [];
    this.state.approvalFor.forEach((element: any) => {
      approvalUsers.push(this.userList[element].iamUserId);
    });

    let isApproverInvalid = false;
    let multiApprovalDetails: any = [];
    let approvalRequiredUsers = [];
    if(this.isExpense) {
      approvalRequiredUsers = this.state.userList
      .filter(u => u.userGroup.id === this.state.groupValue.id)
      .map(u => u.iamUserId) || [];
    } else {
      approvalRequiredUsers = this.state.userList?.map(u => u.iamUserId) || [];
    }
    
    this.state.multiApprovalDetails.forEach(
      (item: {
        availableApproverList: any[];
        approver: any[];
        level: any;
        levelLabel: any;
        condition: any;
      }) => {
        let approvarUsers: any = [];
        if (item.approver.length <= 0) {
          isApproverInvalid = true;
        }
        item.approver.forEach((element: any) => {
          approvarUsers.push(item.availableApproverList[element].iamUserId);
          if(this.state.isAllRequiredUser?.value) {
            approvalRequiredUsers.splice(approvalRequiredUsers.indexOf(item.availableApproverList[element].iamUserId),1)
          }
        });
        multiApprovalDetails.push({
          level: item.level,
          levelLabel: item.levelLabel,
          condition: item.condition.id,
          approver: approvarUsers
        });
      }
    );
    if(this.state.isAllRequiredUser?.value && Utility.isEmpty(approvalRequiredUsers)) {
      showAlert('Alert','All employees from an expense group cannot be selected as approvers.');
      return
    }
    let newConfiguration: any = [];
    let iamUserIds = []
    if(this.state.isAllRequiredUser?.value) {
      iamUserIds = approvalRequiredUsers;
    } else {
      iamUserIds = approvalUsers;
    }
    let isValidApprovalFor = true;
    
    await ExpenseService.isUserInExpenseApproval(iamUserIds,true,this.state.workflowId,!this.isExpense).then(res => {
      //continue;
    }, error => {
      isValidApprovalFor= false
      showAlert('Alert','Approval required user is already part of another automation.');
      return
    })
    if(!isValidApprovalFor) {
      return
    }
    if (
      !Utility.isEmpty(configuration) &&
      (
        !Utility.isEmpty(configuration['undefined']) ||
        !Utility.isEmpty(configuration[this.documentType]))
    ) {
      let isValidField = true;
      let isLeaveConditionMatch = true ; 
      newConfiguration = Object.keys(configuration).map((configType) => {
        const fields = configuration[configType];
        const fieldKeys = Object.keys(fields);
        if(!this.isExpense && fieldKeys && fieldKeys.includes('any') && fieldKeys.length > 1) {
          isLeaveConditionMatch = false;
        }
        const newFields: any = fieldKeys.map((fieldKey) => {
          if(Utility.isEmpty(fields[fieldKey].value) || fields[fieldKey].value.includes('-') ) {
            isValidField = false;
          }
          if(!Utility.isEmpty(fields[fieldKey].value) && !this.isExpense && !new RegExp(MULTIPLE_OF_05).test(fields[fieldKey].value)) {
            isValidField = false;
          }
          return {
         
            [remoteTable? TableManger.getColumnById(remoteTable, fieldKey).columnCode:fieldKey]:
              fields[fieldKey].value,
            opr: fields[fieldKey].opr || 'eq',
            type: fields[fieldKey].type || ''
          }
        }
        );
        let newConfig = {
          documentType: "",//note use later // this.documentType,
          approvalFor: approvalUsers.toString(),
          approver: '',
          multiApprovalDetails: multiApprovalDetails,
          sendEmailToApprover: this.state.sendEmailToApprover ? this.state.sendEmailToApprover : false,
          sendReminder:
            (Utility.isEmpty(this.state.reminderDays) ||
              this.state.reminderDays === '0'
              ? false
              : this.state.sendReminder)||false,
          reminderDays: this.state.reminderDays,
          fields: newFields,
          logicalOperator:
            this.isExpense ? (logicalOperator[configType] || this.defaultLogicalOperator) : this.defaultLogicalOperator
        };
        newConfig['group']= this.state.groupValue;
        newConfig['isAllRequiredUser'] = this.state.isAllRequiredUser?.value || false;
        newConfig['approvalRequiredUsers'] = this.state.isAllRequiredUser?.value ? approvalRequiredUsers.join() :""
        return newConfig
      });
      if(!isValidField || this.isMapperInvalid) {
        showAlert('Alert','Please enter the correct condition value');
        return;
      }
      if(!isLeaveConditionMatch) {
        showAlert("Alert", "In conditions, you have select <b>Any</b> then only one condition is possible.")
        return;
      }
    } else {
      let newFields: any = [];
      newConfiguration = [
        {
          documentType: "",//note use later // this.documentType,
          approvalFor: approvalUsers.toString(),
          approver: '',
          multiApprovalDetails: multiApprovalDetails,
          sendEmailToApprover: this.state.sendEmailToApprover ? this.state.sendEmailToApprover : false,
          sendReminder:
            (Utility.isEmpty(this.state.reminderDays) ||
              this.state.reminderDays === '0'
              ? false
              : this.state.sendReminder)||false,
          reminderDays: this.state.reminderDays,
          fields: newFields,
          group: this.state.groupValue,
          logicalOperator: this.defaultLogicalOperator,
          isAllRequiredUser: this.state.isAllRequiredUser?.value || false,
          approvalRequiredUsers: this.state.isAllRequiredUser?.value ? approvalRequiredUsers.join() :""
        }
      ];
    }
    if (isApproverInvalid || (Utility.isEmpty(approvalUsers) && !this.state.isAllRequiredUser?.value)) {
      showAlert(
        ``,
        `Approval required users and Approver users should not be empty.`
      );
      return;
    }
    if(this.state.sendReminder && (Utility.isEmpty(this.state.reminderDays) || this.state.reminderDays < 1 )) {
      showAlert(
        ``,
        `Send email reminder to approver days should be greater than zero.`
      );
      return;
    }
    this.props.onSave(newConfiguration, false);
  };

  ////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////
  //////////////////////RENDERERS/////////////////////////////

  render() {
    return (
      <div className="transparent-background">
        <div
          className="popup-window"
          style={{
            padding: 0,
            maxWidth: 570,
            maxHeight: '95%',
            borderRadius: 0
          }}
        >
          {this.renderHeader()}
          {this.renderBody()}
          {/* {this.renderBottom()} */}
        </div>
      </div>
    );
  }

  renderHeader() {
    return (
      <div
        className="row justify-content-between bg-gray1 p-m"
        style={{ height: 45 }}
      >
        <div className="row">
          <DKLabel text="Approval Conditions" className="fw-m" />
          {this.state.isLoadingApprovalDetails && <DKSpinner className="pl-m" />}
        </div>
        {this.renderBottom()}
        {/* <DKButton
          icon={DKIcons.ic_close}
          onClick={() => this.props.onClose()}
        /> */}
      </div>
    );
  }

  renderBody() {
    const isEmailTypeConfig =
      this.state.activeType === SPLIT_ACTION_TYPE.EMAIL_OPENED ||
      this.state.activeType === SPLIT_ACTION_TYPE.EMAIL_LINK_CLICKED;
    return (
      <div
        className="column align-items-start parent-width p-m custom-scroll"
        style={{ height: '90%', overflowY: 'auto' }}
      >
        {/* {this.renderConfigTypes()} */}
        
        {isEmailTypeConfig
          ? this.renderEmailTypeConfigOptions()
          : this.renderConfigOptions()}
      </div>
    );
  }

  renderConfigTypes() {
    return (
      <Fragment>
        <DKLabel
          text="Apply options from any type(s) below for splitting workflow actions."
          className="p-h-s border-box fs-r parent-width"
        />
        <div
          className="row width-auto mt-l mb-r border-m border-radius-m hide-scroll-bar"
          style={{ overflow: 'auto hidden', flexShrink: 0 }}
        >
          {this.supportedConditionTypes.map((actionType, index) => {
            const actionTypeValue = SPLIT_ACTION_TYPE[actionType];
            const isActiveType = this.state.activeType === actionTypeValue;
            return (
              <DKButton
                key={actionType}
                title={actionTypeValue}
                className={`fs-s fw-m border-radius-none ${isActiveType ? 'bg-button text-white' : ''
                  }`}
                style={{
                  borderLeft: index === 0 ? 'none' : '1px solid #dcdcdc'
                }}
                onClick={() => {
                  this.setState(
                    {
                      columns: {},
                      activeType: actionTypeValue
                    },
                    this.setFieldsData
                  );
                }}
              />
            );
          })}
        </div>
      </Fragment>
    );
  }

  renderConfigOptions() {
    const { columns, activeType, configuration, logicalOperator } = this.state;
    if (!columns || !Object.keys(columns).length)
      return (
        <div className="row bg-gray1 border-m border-radius-m mt-m p-s">
          Loading...
        </div>
      );

    const fields =
      configuration[activeType] || configuration['undefined'] || {};

    let fieldKeys = Object.keys(fields);
    let col = Object.values(columns).filter(
      (ele: any) => fieldKeys[0] === ele.columnCode
    );

    if (col.length > 0) {
      fieldKeys.forEach((field) => {
        fields[this.getColId(field)] = fields[field];
        delete fields[field];
      });
      fieldKeys = Object.keys(fields);
    }

    const fieldMap: any = {};
    fieldKeys.forEach((field) => {
      fieldMap[field] = fields[field].value;
    });

    return (
      <div className="parent-width pb-m">
        <div
          className="parent-width border-box p-h-xs"
          style={{ minHeight: 150 }}
        >
          {this.getDocumentRenderer()}
          {/* {this.getApprovalType()} */}
          <div className="p-h-m">
            
          {fieldKeys?.length ? (
            fieldKeys?.filter(field=>columns[field]?.name)?.map((fieldKey) => (
              <FieldRow
                type={this.props.stepData.type}
                columns={columns}
                elementType={this.props.stepData.elementType}
                field={fieldKey}
                fields={fieldMap}
                operator={fields[fieldKey].opr}
                onChange={(newField: any, oldField: any, isMapperInvalid) => {
                  // note: will use later fir validation
                  // if(!this.isExpense && Object.keys(newField)[0] === 'any' && fieldKeys.length > 1) {
                  //   showAlert("Alert", "In conditions, you have select <b>Any</b> then only one condition is possible.")
                  //   return;
                  // }
                  this.isMapperInvalid = isMapperInvalid
                  this.onFieldUpdate(
                    fieldKey,
                    'value',
                    newField[fieldKey],
                    newField,
                    oldField
                  )
                }
                }
                onConditionChange={(opr: any) =>
                  this.onFieldUpdate(fieldKey, 'opr', opr)
                }
                onFieldRemove={() => this.onFieldRemove(fieldKey)}
              />
            ))
          ) : (
            <DKLabel
              text="No condition is applied for the current type, please add a condition from below."
              className="bg-gray1 mt-l p-r border-radius-m parent-width border-box"
            />
          )}
        </div>
        {fieldKeys.length > 1
          ? this.renderLogicalOperatorButtons(
            this.isExpense ? (logicalOperator[activeType] || this.defaultLogicalOperator) : this.defaultLogicalOperator
          )
          : null}
          </div>
        {fieldKeys.length < Object.keys(columns).length ? (
          <DKButton
            title={`+ Add ${fieldKeys.length === 0 ? 'a' : 'another'
              } condition`}
            className="align-self-start text-app fw-m p-h-m fs-m ml-r mr-r"
            style={{ marginTop: 'auto', paddingBottom: 0, paddingLeft: 0 }}
            onClick={() => this.showRandomField(fieldKeys)}
          />
        ) : null}
      </div>
    );
  }

  getColId(fieldKey: any) {
    let remoteTable = '';
    if (this.documentType === AUTOMATION_TRIGGERS.EXPENSE_CREATED) {
      remoteTable = TABLES.PEOPLE_EXPENSE_CLAIMS;
    }
    return TableManger.getColumnId(remoteTable, fieldKey)
      ? TableManger.getColumnId(remoteTable, fieldKey)
      : fieldKey;
  }
  updateUserList(value) {
    if(this.isExpense) {
      this.userList = this.allUsers.filter(u=>u.userGroup.id == value.id)?.map(u=>{return {...u,iamUserId:parseInt(u.iamUserId)}})
    } else {
      this.userList = value.members?.map(u=>{return {...u,iamUserId:parseInt(u.iamUserId)}})
    }
    
    this.approvalUserChange([]);
    setTimeout(()=>{
      this.setState({
        ...this.state,
        groupValue: value,
        userList: this.userList
      })
    },100)
  }
  getDocumentRenderer() {
    return (
      <div className="column">
        <div className="parent-width">
          {
            <div className="row mb-m p-h-m">
            <DKInput
              title={this.isExpense ? "Expense Group" : "Team"}
              value={this.state.groupValue}
              type={INPUT_TYPE.DROPDOWN}
              options={this.groupList}
              onChange={(value: any) => {
                this.updateUserList(value);
              }}
              formatter={(obj: any) => {
                return obj?.name;
              }}
              tooltip={{
                content: this.isExpense ? 'Select such a Expense group which contains users.': "As per team select respective users will be listed below.",
                className: "warning-tooltip-prop",
              }}
              readOnly={this.state.isLoadingApprovalDetails}
              direction={INPUT_VIEW_DIRECTION.VERTICAL}
              dropdownConfig={{
                style: { minWidth: 230 },
                className: 'shadow-m',
                allowSearch: (this.groupList && this.groupList.length > 5) ? true : false,
                searchableKey: "name",
                data: this.groupList,
                renderer: (index: number, obj: any) => {
                  return obj?.name;
                }
              }}
            />
          </div>}
          {<div className={`p-h-m fs-m `}>
            {
              <DKInput
                className=""
                title={'Applicable to All'}
                value={this.state.isAllRequiredUser}
                type={INPUT_TYPE.DROPDOWN}
                options={
                  APPLICABLE_TO_ALL
                }
                readOnly={this.isExpense && Utility.isEmpty(this.state.groupValue) || this.state.isLoadingApprovalDetails}
                displayKey={"label"}
                formatter={(obj) => {
                  /** How to render a selected option in case of object **/
                  return obj.label;
                }}
                onChange={(value: any) => {
                  let appFor = this.state.approvalFor
                  if(value) {
                    appFor = []
                  }
                  if(this.isExpense) {
                    this.userList = this.allUsers?.filter(u=>u.userGroup.id == this.state.groupValue.id)
                  } else {
                    this.userList = this.state.groupValue?.members?.map(u=>{return {...u,iamUserId:parseInt(u.iamUserId)}}) ?? []
                  }
                  this.approvalUserChange([]);
                  setTimeout(()=>{
                    this.setState({
                      ...this.state,
                      isAllRequiredUser: value,
                      userList: this.userList,
                      approvalFor: appFor
                    })
                  },100)
                }}
                dropdownConfig={{
                  multiSelect: false,
                  checkMarkColor: "bg-app",
                  allowSearch: true,
                  searchableKey: "label",
                  data: APPLICABLE_TO_ALL,
                  renderer: (i, obj) => {
                    return obj.label
                  },
                }}
                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                required={true}
              />
            }
          </div>}
          {!this.state.isAllRequiredUser?.value && <div className={`p-h-m fs-m `}>
            {
              <DKInput
                className="pt-m"
                title={'Approval required users'}
                value={(Array.isArray(this.state.userList) && this.state.userList.length>0) ? this.state.approvalFor:[]}
                type={INPUT_TYPE.DROPDOWN}
                options={
                  this.state.userList 
                }
                readOnly={this.isExpense && Utility.isEmpty(this.state.groupValue) || this.state.isLoadingApprovalDetails}
                displayKey={"name"}
                formatter={(obj) => {
                  /** How to render a selected option in case of object **/
                  return obj;
                }}
                onChange={(value: any) => {
                  
                  this.approvalUserChange(value);
                }}
                dropdownConfig={{
                  multiSelect: true,
                  checkMarkColor: "bg-app",
                  allowSearch: true,
                  searchableKey: "name",
                  data: this.state.userList.map(u=> {
                    return {
                      ...u, name: u.firstName +" "+u.lastName
                    }
                  } ) ,
                  renderer: (i, obj) => {
                    return `${obj?.name} (${this.isExpense ?  obj.userRole?.name : obj.roles.join(",") })`
                  },
                }}
                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                required={true}
              />
            }
          </div>}
          
        </div>
        <div className="row justify-content-between mt-m ">
          <div
            className="row p-h-m fs-m  mr-r cursor-hand position-relative justify-content-between"
            style={{ height: 37 }}
          >
            <div
              className="parent-width parent-height position-absolute"
              style={{ top: 0, left: 0 }}
            />
            <DKLabel text={'Approver Levels'} className="" />
          </div>
        </div>
        {this.renderApprovalLevels()}
        <DKButton
          title={`+ Add another level`}
          className="align-self-start text-app fw-m p-h-m fs-m ml-r mr-r"
          style={{ marginTop: 'auto', paddingBottom: 0, paddingLeft: 0 }}
          onClick={() => {
            this.addApprovalLevel();
          }}
        />
        <div className="row justify-content-start mt-m p-h-m fs-m  mr-r">
          <DKLabel
            text={'Send email to Approvers'}
            className="mr-5"
            style={{ width: 240 }}
          />
          {this.renderAttachmentCheck()}
        </div>
        <div className="row justify-content-start p-h-m fs-m  mr-r">
          <DKLabel
            text={'Send Reminder'}
            className="mr-5"
            style={{ width: 240 }}
          />
          {this.renderReminderCheck()}
        </div>
        <div className="row justify-content-start">
          {
            <div
              className={`row justify-content-start pb-l p-h-m mt-m ml-15 ${this.state.sendReminder ? 'text-black' : 'text-gray'
                }`}
            >
              <DKLabel
                text="If not approved send email reminder to approver in"
                className=""
              />
              <div style={{ width: '80px' }} className="p-h-m">
                <DKInput
                  value={this.state.reminderDays}
                  type={INPUT_TYPE.NUMBER}
                  onChange={(value: any) =>
                    this.setState({ reminderDays: value })
                  }
                  canValidate={this.state.sendReminder}
                  validator={(o)=>{
                    return o>=1
                  }}
                  errorMessage={"Minimum 1 day"}
                  direction={INPUT_VIEW_DIRECTION.VERTICAL}
                  required={this.state.sendReminder}
                  readOnly={!this.state.sendReminder}
                  className={`${this.state.sendReminder ? 'text-black' : 'text-gray'
                    }`}
                />
              </div>
              <DKLabel text={parseFloat(this.state.reminderDays) === 1 ? "day" : "days"} className="" />
            </div>
          }
        </div>
      </div>
    );
  }
  // Note : will remove later
  getApprovalType() {
    return (
      <div className="column mt-m p-h-m">
        <div className="row ">
          <DKInput
            title="Approval Type"
            value={this.listForApprovalType.find(list => list.type === this.state.activeType)}
            type={INPUT_TYPE.DROPDOWN}
            options={this.listForApprovalType}
            onChange={(value: any) => {
            }}
            formatter={(obj: any) => {
              return obj.label;
            }}
            readOnly={true}
            direction={INPUT_VIEW_DIRECTION.VERTICAL}
            dropdownConfig={{
              style: { minWidth: 230 },
              className: 'shadow-m',
              allowSearch: false,
              canEdit: false,
              canDelete: false,
              data: this.listForApprovalType,
              renderer: (index: number, obj: any) => {
                return <DKLabel text={obj.label} />;
              }
            }}
          />
        </div>
        <div className="row mt-l">
          <DKInput
            title={this.state.activeType === AUTOMATION_TRIGGERS.EXPENSE_CREATED ? "Expense Group":"Leave Type"}
            value={this.groupList ? this.groupList[0]:""}
            type={INPUT_TYPE.DROPDOWN}
            options={this.groupList}
            onChange={(value: any) => {
              
            }}
            formatter={(obj: any) => {
              return obj?.name;
            }}
            direction={INPUT_VIEW_DIRECTION.VERTICAL}
            dropdownConfig={{
              style: { minWidth: 230 },
              className: 'shadow-m',
              allowSearch: (this.groupList && this.groupList.length > 5) ? true:false,
              
              data: this.groupList,
              renderer: (index: number, obj: any) => {
                return obj?.name;
              }
            }}
          />
        </div>
      </div>
    )
  }

  renderApprovalLevels() {
    return (
      <div className="parent-width">
        {this.state.multiApprovalDetails.map((item: any, index: number) => {
          return (
            <div
              key={item.level}
              className="mt-m mr-m ml-m border-m shadow-s-2 border-radius-s input-width"
            >
              <div className="row justify-content-between mt-m ">
                <div
                  className="row p-h-m fs-m  mr-r cursor-hand position-relative justify-content-between"
                  style={{ height: 37 }}
                >
                  <div
                    className="parent-width parent-height position-absolute"
                    style={{ top: 0, left: 0 }}
                  />
                  <DKLabel text={'Level Name'} className="" />
                </div>
                {index != 0 ? (
                  <DKButton
                    icon={DKIcons.ic_delete}
                    onClick={() => this.removeApprovalLevel(item.level)}
                  />
                ) : (
                  ''
                )}
              </div>
              <div className="row p-h-m fs-m  mr-r cursor-hand position-relative justify-content-between">
                {
                  <DKInput
                    value={item.levelLabel}
                    type={INPUT_TYPE.TEXT}
                    onChange={(value: any) => {
                      this.approverLevelFieldChange(index, 'levelLabel', value);
                    }}
                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                    required={true}
                  />
                }
              </div>
              <div className="row justify-content-between mt-m ">
                <div
                  className="row p-h-m fs-m  mr-r cursor-hand position-relative justify-content-between"
                  style={{ height: 37 }}
                >
                  <div
                    className="parent-width parent-height position-absolute"
                    style={{ top: 0, left: 0 }}
                  />
                  <DKLabel text={'Approver users*'} className="" />
                </div>
              </div>
              <div className="row p-h-m fs-m  mr-r cursor-hand position-relative justify-content-between">
                {
                  <DKInput
                    value={item.approver}
                    type={INPUT_TYPE.DROPDOWN}
                    options={
                      item?.availableApproverList?.map(u=> {
                        return {
                          ...u, name: u.firstName +" "+u.lastName
                        }
                      }) || []
                    }
                    readOnly={this.isExpense && Utility.isEmpty(this.state.groupValue) || this.state.isLoadingApprovalDetails}
                    displayKey={"name"}
                    formatter={(obj) => {
                      /** How to render a selected option in case of object **/
                      return obj?.name;
                    }}
                    onChange={(value: any) => {
                      this.approverLevelFieldChange(index, 'approver', value);
                    }}
                    dropdownConfig={{
                      multiSelect: true,
                      checkMarkColor: "bg-app",
                      allowSearch: true,
                      searchableKey: "name",
                      data: item?.availableApproverList?.map(u=> {
                        return {
                          ...u, name: u.firstName +" "+u.lastName
                        }
                      }) || [] ,
                      renderer: (i, obj) => {
                        return `${obj?.name} (${this.isExpense ? obj.userRole?.name : obj.roles.join(",")})`;
                      },
                    }}
                    
                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                    required={true}
                  />
                }
              </div>
              <div className="row justify-content-start">
                {
                  <div
                    className={
                      'row justify-content-start pb-l p-h-m mt-m ml-15 text-black'
                    }
                  >
                    <DKLabel text="Approval required from " className="" />
                    <div style={{ width: '80px' }} className="p-h-m">
                      <DKInput
                        value={item.condition}
                        type={INPUT_TYPE.DROPDOWN}
                        options={APPROVAL_REQURIED_CONDITION}
                        onChange={(value: any) => {
                          this.approverLevelFieldChange(
                            index,
                            'condition',
                            value
                          );
                        }}
                        formatter={(obj: any) => {
                          return obj.label;
                        }}
                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                        dropdownConfig={{
                          style: { minWidth: 230 },
                          className: 'shadow-m',
                          allowSearch: false,
                          canEdit: false,
                          canDelete: false,
                          data: APPROVAL_REQURIED_CONDITION,
                          renderer: (index: number, obj: any) => {
                            return <DKLabel text={obj.label} />;
                          }
                          // onSelect: (index: number, value: any) => {},
                        }}
                      />
                    </div>
                    <DKLabel text=" Approvers" className="" />
                  </div>
                }
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  renderAttachmentCheck() {
    return (
      <div className="pb-l p-h-m mt-m">
        <DKCheckMark
          className="text-black"
          isSelected={this.state['sendEmailToApprover']}
          onClick={this.onClickCheckBoxForSetting}
        />
      </div>
    );
  }
  renderReminderCheck() {
    return (
      <div className="pb-l p-h-m mt-m">
        <DKCheckMark
          className="text-black"
          isSelected={this.state['sendReminder']}
          onClick={this.onClickCheckBoxForReminder}
        />
      </div>
    );
  }
  onClickCheckBoxForSetting = (value: any | null) => {
    this.setState({ sendEmailToApprover: !this.state['sendEmailToApprover'] });
  };
  onClickCheckBoxForReminder = (value: any | null) => {
    this.setState({ sendReminder: !this.state['sendReminder'] });
    if (
      this.state['sendReminder'] &&
      Utility.isEmpty(this.state.reminderDays)
    ) {
      this.setState({ reminderDays: '7' });
    }
  };
  onOptionChange(index: any) {
    this.documentType = DOCUMENTS[index].id;
    this.setState({
      documentType: DOCUMENTS[index].id,
      activeType: DOCUMENTS[index].id
    });
    this.setFieldsData();
  }
  approvalUserChange(value: any) {
    let emailArray: any = [];
    let approvalForEmails: any = [];
    this.teams = []
    value.forEach((element: any) => {
      let emailAddress = this.userList[element];
      if (!Utility.isEmpty(emailAddress)) {
        emailArray.push(emailAddress.iamUserId);
        approvalForEmails.push(emailAddress.iamUserId);
        // Note; this filter will use later
        // if(this.state.activeType === AUTOMATION_TRIGGERS.PEOPLE_LEAVE_CREATED) {
        //   emailAddress.teams.forEach(i=>{
        //     return this.teams = [...this.teams, ...i['members']]
        //   })
        // }

      }
    });

    this.state.multiApprovalDetails.forEach((item: any) => {
      if (item.approver && item.approver.length > 0) {
        item.approver &&
          item.approver.forEach((element: any) => {
            emailArray.push(item.availableApproverList[element].iamUserId);
          });
      }
    });

    const filtered = this.state.multiApprovalDetails.map((item: any) => {
      let currentEmailUsers: any = [];
      item.approver.forEach((element: any) => {
        currentEmailUsers.push(item.availableApproverList[element].iamUserId);
      });
      const filetedUsers = this.userList.filter(
        (ele: any) =>
          !emailArray.includes(ele.iamUserId) ||
          (currentEmailUsers.includes(ele.iamUserId) &&
            !approvalForEmails.includes(ele.iamUserId)) 
            // Note; this filter will use later
            // &&
            // (
            //   this.state.activeType === AUTOMATION_TRIGGERS.PEOPLE_LEAVE_CREATED && this.teams.find(t=> t.iamUserId === ele.iamUserId) ||
            //   this.state.activeType === AUTOMATION_TRIGGERS.EXPENSE_CREATED && this.teams.find(t=> t.iamUserId === ele.iamUserId) // change need
            // )
      )?.map(user=>{
        return{
          ...user,
          iamUserId: parseInt(user.iamUserId)
        }
      });
      return {
        ...item,
        approver: currentEmailUsers
          .map((item: any) => {
            return filetedUsers.findIndex(
              (f: { iamUserId: any }) => item == f.iamUserId
            );
          })
          .filter((i: number) => i !== -1),
        availableApproverList: filetedUsers
      };
    });
    this.approverList = this.userList?.filter((ele: any) => {
      return emailArray.indexOf(ele) === -1;
    });

    let approverData: any = [];
    this.state.approver.forEach((element: any) => {
      let obj = this.approverList[element];
      if (!Utility.isEmpty(obj)) {
        approverData.push(element);
        this.setState({ approver: approverData });
      }
    });

    this.setState({ approvalFor: value, multiApprovalDetails: filtered });
  }
  getApprovalForList() {// initial call
    let config = this.props.stepData?.configuration;
    let approverForlist =
      !Array.isArray(config && config[0]) &&
      config &&
      config[0] !== '' &&
      config &&
      !Utility.isEmpty(config[0].approvalFor) &&
      config[0].approvalFor.split(',');
    let userData: any = [];
    
      let group = this.props.stepData?.configuration && this.props.stepData?.configuration[0].group
      if(this.isExpense) {
        this.userList = this.allUsers.filter(u=>u.userGroup.id == group?.id);
      } else {
        const teamList = Store.getState().payroll?.formData?.teams['teams']
        if (this.props.stepData?.configuration && this.props.stepData?.configuration[0].group) {
          group = this.props.stepData?.configuration && this.props.stepData?.configuration[0].group
          if (teamList) {
            group = teamList.find(t => t.teamId === group.teamId)
          }
        }
        this.userList = ((group && group.members) ? group.members : this.allUsers)?.map(u => { return { ...u, iamUserId: parseInt(u.iamUserId) } })
      }
      if (approverForlist && approverForlist.length > 0) {
        approverForlist.forEach((element: any) => {
            const index = this.userList?.findIndex(
              (user: any) => user.iamUserId == element
            );
            if (index !== -1) {
              userData.push(index);
            }
          });
        this.setState({ ...this.state,approvalFor: userData, groupValue: group,userList:this.userList }); // exp only
        setTimeout(()=>{
          this.approvalUserChange(userData);
        },100)
    } else {
      this.setState({ ...this.state,approvalFor: userData, groupValue: group,userList:this.userList }); // exp only
      setTimeout(()=>{
        this.approvalUserChange(userData);
      },100)
      userData = [];
    }

    return userData;
  }

  approverUserChange(value: any) {
    this.setState({ approver: value });
  }

  approverLevelFieldChange(index: number, fieldName: string, value: any) {
    const approvalDetails = this.state.multiApprovalDetails[index];
    const updatedApprovalDetails = { ...approvalDetails, [fieldName]: value };
    const updated = this.state.multiApprovalDetails;
    updated[index] = updatedApprovalDetails;

    if (fieldName == 'approver') {
      let emailArray: any = [];
      updated.forEach((item: any) => {
        item.approver?.forEach((element: any) => {
          let emailAddress = item.availableApproverList[element];
          if (!Utility.isEmpty(emailAddress)) {
            emailArray.push(emailAddress.iamUserId);
          }
        });
      });

      this.state.approvalFor.forEach((element: any) => {
        let emailAddress = this.userList[element];
        if (!Utility.isEmpty(emailAddress)) {
          emailArray.push(emailAddress.iamUserId);
        }
      });

      const filtered = updated.map((item: any) => {
        let currentEmailUsers: any = [];
        item.approver.forEach((element: any) => {
          currentEmailUsers.push(item.availableApproverList[element].iamUserId);
        });
        const filetedUsers = item.availableApproverList.filter(
          (ele: any) =>
            emailArray.indexOf(ele.iamUserId) === -1 ||
            currentEmailUsers.includes(ele.iamUserId)
        );
        return {
          ...item,
          approver: currentEmailUsers
            .map((item: any) => {
              return filetedUsers.findIndex(
                (f: { iamUserId: any }) => item == f.iamUserId
              );
            })
            .filter((i: number) => i !== -1),
          availableApproverList: filetedUsers
        };
      });
      this.setState({ multiApprovalDetails: filtered });
    } else {
      this.setState({ multiApprovalDetails: updated });
    }
    setTimeout(()=>{
      this.approvalUserChange(this.state.approvalFor);
    },100)
  }

  getApproverList() {
    let config = this.props.stepData?.configuration;
    let approverlist =
      !Array.isArray(config && config[0]) &&
      config &&
      config[0] !== '' &&
      config &&
      !Utility.isEmpty(config[0].approver) &&
      config[0].approver.split(',');
    let userData: any = [];
    if (approverlist && approverlist.length > 0) {
      
      approverlist &&
        approverlist.forEach((element: any) => {
          const index = this.approverList?.findIndex(
            (user: any) => user && user.iamUserId === element
          );
          if (index !== -1) {
            userData.push(index);
          }
        });
      this.setState({ approver: userData });
    } else {
      userData = [];
      this.approverList = [];
    }
    return userData;
  }

  getMultiApprovalConfigFromApprover() {
    if (
      this.props.stepData?.configuration &&
      this.props.stepData?.configuration[0].approver
    ) {
      let userData: any = [];
      if (
        this.props.stepData?.configuration[0].approver &&
        this.props.stepData?.configuration[0].approver.length > 0
      ) {
        this.props.stepData?.configuration[0].approver
          .split(',')
          .forEach((element: any) => {
            const index = this.userList?.findIndex(
              (user: any) => user && user.iamUserId === element
            );
            if (index !== -1) {
              userData.push(index);
            }
          });
      } else {
        userData = [];
      }
      return { ...this.getDefaultMultiApprovalConfig(), approver: userData };
    } else {
      return [];
    }
  }

  getMultiApprovalListFromProps() {
    if (
      this.props.stepData?.configuration &&
      this.props.stepData?.configuration[0].multiApprovalDetails
    ) {
      let emailArray: any = [];
      this.props.stepData?.configuration[0].multiApprovalDetails.forEach(
        (item: any) => {
          if (item.approver && item.approver.length > 0) {
            item.approver &&
              item.approver.forEach((element: any) => {
                emailArray.push(element);
              });
          }
        }
      );

      let approverForlist =
        !Array.isArray(
          this.props.stepData?.configuration &&
          this.props.stepData?.configuration[0]
        ) &&
        this.props.stepData?.configuration &&
        this.props.stepData?.configuration[0] !== '' &&
        this.props.stepData?.configuration &&
        !Utility.isEmpty(this.props.stepData?.configuration[0].approvalFor) &&
        this.props.stepData?.configuration[0].approvalFor?.split(',');
        if(approverForlist?.forEach) {
          approverForlist?.forEach((element: any) => {
            emailArray.push(element);
          });
        }

      let multiApprovalDetails: any[] = [];
      this.props.stepData?.configuration[0].multiApprovalDetails.forEach(
        (item: any) => {
          let userData: any = [];
          let currentEmailUsers: any = [];
          if (item.approver && item.approver.length > 0) {
            item.approver &&
              item.approver.forEach((element: any) => {
                const index = this.userList?.findIndex(
                  (user: any) => user && user.iamUserId === element
                );
                if (index !== -1) {
                  userData.push(index);
                  currentEmailUsers.push(element);
                }
              });
          } else {
            userData = [];
          }
          const filetedUsers = this.userList.filter(
            (ele: any) =>
              !emailArray.includes(ele.iamUserId) ||
              currentEmailUsers.includes(ele.iamUserId)
              // && team chk
          )?.map(user=>{
            return{
              ...user,
              iamUserId: parseInt(user.iamUserId)
            }
          });
          multiApprovalDetails.push({
            approver: currentEmailUsers
              .map((item: any) => {
                return filetedUsers.findIndex(
                  (f: { iamUserId: any }) => item == f.iamUserId
                );
              })
              .filter((i: number) => i !== -1),
            availableApproverList: filetedUsers,
            level: item.level,
            condition: APPROVAL_REQURIED_CONDITION.find(
              (i: { id: any }) => i.id == item.condition
            ),
            levelLabel: item.levelLabel
          });
        }
      );
      return multiApprovalDetails;
    } else {
      return [];
    }
  }

  getFilteredApproverList() {
    const approverList: string[] = [];
    const allApprovalList = this.state.userList ? this.state.userList : [];
    this.state.multiApprovalDetails.forEach((i: { approver: [any] }) =>
      i.approver.forEach((k) => approverList?.push(k.iamUserId))
    );
    this.state.approvalFor.forEach((i: any) =>
      approverList?.push(this.userList[i].iamUserId)
    );
    return allApprovalList.filter((item: any) => {
      return approverList?.findIndex((l: string) => item.iamUserId == l);
    });
  }

  getDefaultMultiApprovalConfig() {
    const levelIndex = this.state?.multiApprovalDetails
      ? this.state.multiApprovalDetails.length + 1
      : 1;
    const approverList =
      this.state?.multiApprovalDetails &&
        this.state?.multiApprovalDetails.length > 0
        ? this.state.multiApprovalDetails[
          this.state?.multiApprovalDetails.length - 1
        ].availableApproverList
        : this.userList;

    let emailArray: any = [];
    this.state?.multiApprovalDetails.forEach((item: any) => {
      item.approver?.forEach((element: any) => {
        let emailAddress = item.availableApproverList[element];
        if (!Utility.isEmpty(emailAddress)) {
          emailArray.push(emailAddress.iamUserId);
        }
      });
    });

    this.state.approvalFor.forEach((element: any) => {
      let emailAddress = this.userList[element];
      if (!Utility.isEmpty(emailAddress)) {
        emailArray.push(emailAddress.iamUserId);
      }
    });

    const filteredApprovalList = approverList?.filter(
      (l: { iamUserId: any }) => !emailArray.includes(l.iamUserId)
      ///// && team chk
    );
    return {
      level: this.state?.multiApprovalDetails
        ? this.state.multiApprovalDetails.length + 1
        : 1,
      levelLabel: 'Level ' + levelIndex,
      approver: [],
      condition: { id: 'ANY', label: 'any' },
      availableApproverList: filteredApprovalList
    };
  }
  isSaveDisabled() {
    let isDisabled: boolean = false;
    let loginUser = UserManager.getUserDetails();
    const roleShortInfoList = loginUser && loginUser.roleShortInfo;
    if (roleShortInfoList && Array.isArray(roleShortInfoList)) {
      const app = roleShortInfoList.find((appObj) => appObj.appName === 'PEOPLE');
      if (app && app.roleGroupName !== 'Admin' && !PermissionUtils.hasAccess(MODULE.AUTOMATION,[ACTION.CREATE,ACTION.EDIT])) {
        isDisabled = true;
      }
    }
    return isDisabled;
  }
  renderLogicalOperatorButtons(activeOperator: any) {
    return (
      <div className="d-flex justify-content-center">
        <div className="align-self-center d-flex mt-r bg-white border-m shadow-s-2 border-radius-s">
          {this.isExpense && <div
            className="cursor-hand"
            onClick={() => this.handleOperatorChange('and')}
          >
            <DKLabel
              text="And"
              className={
                'p-v-xs p-h-s ' +
                (activeOperator === 'and' ? 'bg-gray1 fw-m' : 'text-gray')
              }
            />
          </div>}
          <div
            className="cursor-hand"
            onClick={() => this.handleOperatorChange('or')}
          >
            <DKLabel
              text="Or"
              className={
                'p-v-xs p-h-s ' +
                (activeOperator === 'or' ? 'bg-gray1 fw-m' : 'text-gray')
              }
            />
          </div>
        </div>
      </div>
    );
  }

  renderEmailTypeConfigOptions() {
    const { columns, configuration, needEmailConfigSelection, activeType } =
      this.state;

    const currentOptionKey =
      configuration[activeType] && Object.keys(configuration[activeType])[0];
    const currentOptionValue =
      configuration[activeType] &&
        configuration[activeType][currentOptionKey].opr === 'gt'
        ? 1
        : 0;

    const currentOptionColumnData = currentOptionKey
      ? columns[`${currentOptionKey}_${currentOptionValue}`]
      : null;

    return (
      <Fragment>
        <DKLabel
          text="How would you like to split the path?"
          className="p-h-s border-box fs-r parent-width"
        />
        <div
          className="column mt-l m-h-r position-relative"
          style={{ minHeight: 150 }}
        >
          <DKButton
            className={`${currentOptionColumnData ? '' : 'text-red'
              } border-m split-email-config-button`}
            style={{ borderRadius: 6 }}
            title={currentOptionColumnData.name || 'Select a condition'}
            isReverse={true}
            icon={DKIcons.ic_arrow_down}
            onClick={() => {
              this.setState({ needEmailConfigSelection: true });
            }}
          />
          {needEmailConfigSelection ? (
            <DKListPicker
              data={Object.values(columns).map(
                (columnData: any) => columnData?.name
              )}
              className="position-absolute shadow-m border-m z-index-3"
              style={{ top: 0, left: 0, width: 250 }}
              onSelect={(index: any, option: any) => {
                const selectedFieldData: any = Object.values(columns).find(
                  (columnData: any) => option === columnData?.name
                );

                this.setState({
                  activeType: selectedFieldData.splitConfigType,
                  configuration: {
                    [selectedFieldData.splitConfigType]: {
                      [selectedFieldData.key]: {
                        value: 0,
                        opr: selectedFieldData.value ? 'gt' : 'eq'
                      }
                    }
                  }
                });

                this.setState({
                  needEmailConfigSelection: false
                });
              }}
              onClose={() => {
                this.setState({ needEmailConfigSelection: false });
              }}
            />
          ) : null}
          {currentOptionColumnData ? (
            <DKLabel
              text={`Further workflow will get evaluated based on condition: ${currentOptionColumnData.name.toLowerCase()}.`}
              className="mt-l p-s border-box fs-r border-m border-radius-s bg-gray1 parent-width"
            />
          ) : null}
        </div>
      </Fragment>
    );
  }

  renderBottom() {
    return (
      <div className="row-reverse row width-auto" style={{ height: 60 }}>
        <DKButton
          title="Save"
          className="bg-button text-white ml-m"
          onClick={() => this.onSave()}
        // disabled={this.isSaveDisabled()}
        />

        <DKButton
          title="Cancel"
          className="bg-gray1 border-m"
          onClick={() => this.props.onClose()}
        />
      </div>
    );
  }
}

export default ApprovalActionPopup;
